<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>
            <span class="md:flex hidden items-center">
                <span>Developed with&nbsp;</span>
                <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6"/>
                <span>&nbsp;<a href="https://xware.co" target="_blank" rel="nofollow">xWARE</a> Team</span>
            </span>
            <span>{{ new Date().getFullYear() }} All rights reserved. Maestro IoT.</span>
        </span>
        <span>
            <span>Contact Us: <a href="mailto:support@maestro-iot.com">support@maestro-iot.com</a></span>
        </span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
